import type Employee from '@src/Objects/Employee';

export enum EMessageType {
    DIRECT = 'direct',
    SYSTEM = 'system',
    NOTIFICATION = 'notification',
    AGENT = 'agent',
}

export interface IMessage {
    id: string;
    type: EMessageType;
    from: Employee | 'system';
    to: Employee[];
    subject: string;
    content: string;
    timestamp: Date;
    read: boolean;
    threadId?: string;
    priority?: 'low' | 'normal' | 'high';
}

export interface IMessageThread {
    id: string;
    participants: Employee[];
    messages: IMessage[];
    lastActivity: Date;
    subject: string;
    unreadCount: number;
}

export interface IMessageDraft {
    to: Employee[];
    subject: string;
    content: string;
}
